import { createSlice } from '@reduxjs/toolkit'

const initialState: any = {
}

const onboardDetailsSlice = createSlice({
    name: 'onboard',
    initialState,
    reducers: {
        setOnboardDetails: (state, action) => {
            return { ...state, ...action.payload };
        }
    },
});

export const { setOnboardDetails } = onboardDetailsSlice.actions;

export default onboardDetailsSlice.reducer